import { ReactElement } from 'react';
import { usePaymentCoordinator } from '../../hooks/payment/usePaymentCoordinator';
import LoadingIndicator from '../loading/LoadingIndicator';

interface Props {
  children: ReactElement;
  fallback?: ReactElement;
}

const PaymentInitializer = (props: Props): ReactElement => {
  const { fallback, children } = props;

  const { paymentsInitialized } = usePaymentCoordinator();

  if (!paymentsInitialized) {
    return fallback ?? <LoadingIndicator lg={30} md={20} sm={16} />;
  }

  return children;
};

export default PaymentInitializer;
